import { render, staticRenderFns } from "./CarouselZoomerModal.vue?vue&type=template&id=522b106c&scoped=true&"
import script from "./CarouselZoomerModal.vue?vue&type=script&lang=js&"
export * from "./CarouselZoomerModal.vue?vue&type=script&lang=js&"
import style0 from "./CarouselZoomerModal.vue?vue&type=style&index=0&id=522b106c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b106c",
  null
  
)

export default component.exports